import React from "react";
import { useGetTransactionStatsByType } from "utils/api/user.api";
import { TRANSACTION_TYPE } from "utils/types/user.type";

interface TransactionStatsProps {
  activeTab?: string;
}

export default function TransactionStats({ activeTab }: TransactionStatsProps) {
  // Map active tab to API type
  const getStatsType = (): "Deposit" | "Withdraw" | "Buy_Sell" | "Swap" | undefined => {
    if (activeTab === TRANSACTION_TYPE.WITHDRAW) return "Withdraw";
    if (activeTab === TRANSACTION_TYPE.DEPOSIT) return "Deposit";
    if (activeTab === TRANSACTION_TYPE.SWAP) return "Swap";
    if (activeTab === "buy_sell") return "Buy_Sell";
    return undefined;
  };

  const statsType = getStatsType();
  const { data: stats, isLoading } = useGetTransactionStatsByType(
    statsType ?? "Deposit"
  );

  if (isLoading || !stats) {
    return (
      <div className="grid grid-cols-12 gap-4 lg:gap-8 mt-4 mb-8">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="col-span-12 md:col-span-6 lg:col-span-3">
            <div className="hover:bg-cyan-800 bg-cyan-300 rounded-2xl transition p-6">
              <div className="animate-pulse">
                <div className="h-4 bg-gray-400 rounded w-24 mb-3"></div>
                <div className="h-8 bg-gray-400 rounded w-16"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  const statCards = [
    {
      title: "Total Transactions",
      value: stats.totalTransactions.toLocaleString(),
    },
    {
      title: "Total Volume",
      value: `${Number(stats.totalVolume).toLocaleString(undefined, {
        maximumFractionDigits: 4,
      })}`,
    },
    {
      title: "Success Rate",
      value: `${Number(stats.successRate).toFixed(2)}%`,
    },
    {
      title: "Recent (24h)",
      value: stats.recent24h.toLocaleString(),
    },
  ];

  return (
    <div>
      {/* Main Stats Cards */}
      <div className="grid grid-cols-12 gap-4 lg:gap-8 mt-4 mb-8">
        {statCards.map((stat, index) => (
          <div
            key={index}
            className="col-span-12 md:col-span-6 lg:col-span-3"
          >
            <div className="hover:bg-cyan-800 bg-cyan-300 rounded-2xl transition p-6">
              <p className="text-black-800 text-sm font-semibold mb-3">
                {stat.title}
              </p>
              <h4 className="text-black-800 text-2xl font-semibold">
                {stat.value}
              </h4>
            </div>
          </div>
        ))}
      </div>

    </div>
  );
}

